/**
* actives
*/

<template>
    <div class="days-wrap">
        <div v-if="readOnly" class="days">
            <span
                v-for="(item, index) in days"
                :key="index"
                :class="actives && actives[item] ? 'active' : ''">
                {{ item.substr(0, 1).toUpperCase() }}
            </span>
        </div>
        <div v-else class="days">
            <!--:class="active.includes(item) && !Object.keys(disabled).includes(item) ? 'active' : '' || Object.keys(disabled).includes(item) ? 'disabled' : ''"-->
            <span
                v-for="(item, index) in days"
                :key="index"
                :class="active.includes(item) ? 'active' : ''"
                @click="handleClick(item)">
                {{ item.substr(0, 1).toUpperCase() }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Days',
        props: {
            actives: {
                type: Object,
                default: null
            },
            readOnly: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        data() {
            return {
                days: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
                active: []
            };
        },
        watch: {
            actives(val) {
                const arr = [];
                for(let key in val) {
                    if(val[key]) arr.push(key);
                }
                this.active =  arr;
            }
        },
        mounted() {
            const arr = [];
            for(let key in this.actives) {
                if(this.actives[key]) arr.push(key);
            }
            this.active =  arr;
        },
        methods: {
            handleClick(item) {
                if(Object.keys(this.disabled).includes(item)) return;
                if (this.active.includes(item)) {
                    this.active = this.active.filter(val => val !== item);
                } else {
                    this.active.push(item);
                }
                const fortmartActive = {};
                this.active.map(val => {
                    fortmartActive[val] = true;
                })
                const str = `${this.active.includes('sun')}_${this.active.includes('mon')}_${this.active.includes('tue')}_${this.active.includes('wed')}_${this.active.includes('thu')}_${this.active.includes('fri')}_${this.active.includes('sat')}`;
                this.$emit('callback', fortmartActive, this.active, str);
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
    .days-wrap {
        .days {
            display: flex;
            justify-content: space-around;
            span {
                display: inline-block;
                margin-right: 10px;
                font-size: 11px;
                text-align: center;
                height: 24px;
                width: 24px;
                line-height: 24px;
                cursor: pointer
            }
            span:last-child {
                margin-right: 0;
            }
            .active {
                background-color: #E6F4C1;
                font-family: Roboto-Bold;
                font-size: 14px;
                color: #000000;
                border-radius: 50%;
            }
            .disabled {
                font-size: 14px;
                border-radius: 50%;
                background-color: #e8e8e8;
                color: #bcbcbc;
                cursor: not-allowed;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/components/Days.vue